import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  connect() {
    const options = {
      html: true,
      content: document.querySelector('[data-name="popover-content"]'),
      title: 'Notifications'
    }
    const button = document.getElementById('notifications-popover-button')
    const popover = new Popover(button, options)
  }
}
